import { render, staticRenderFns } from "./clinicApply.vue?vue&type=template&id=217f6696&scoped=true&"
import script from "./clinicApply.vue?vue&type=script&lang=js&"
export * from "./clinicApply.vue?vue&type=script&lang=js&"
import style0 from "./clinicApply.vue?vue&type=style&index=0&id=217f6696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f6696",
  null
  
)

export default component.exports